

























































// Vue
import { defineComponent, ref, Ref } from '@vue/composition-api'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'

// services
import { ReasonForTerminationWorkService } from '@/services/config'

// Models
import { Paginator } from '@/models'
import { ReasonForTerminationWorkModel } from '@/models/config'

export default defineComponent({
    name: 'TableListReasonForTerminationWork',
    components: {
        DataTable,
        IsActive
    },
    setup () {
        const loading = ref(false)
        const items: Ref<ReasonForTerminationWorkModel[]> = ref([])
        const pagination: Ref<Paginator> = ref({
            currentPage: 1,
            total: 0,
            count: 0,
            perPage: 10
        })
        const fields = ref([
            {
                key: 'name',
                sortable: true,
                label: 'Nombre'
            },
            {
                key: 'status_text',
                sortable: true,
                label: 'Status'
            },
            {
                key: 'actions',
                sortable: false,
                label: '',
                thClass: 'one-line w-30',
                thStyle: {
                    width: '8%'
                }
            }
        ])
        const getreasonsWithPagination = async () => {
            loading.value = true
            const response = await ReasonForTerminationWorkService.getWithPagination(pagination.value.perPage, pagination.value.currentPage)
            items.value = response.objects
            pagination.value = response.pagination
            loading.value = false
        }

        const changePage = (page: number) => {
            pagination.value.currentPage = page
            getreasonsWithPagination()
        }

        const changePerPage = (perPage: number) => {
            pagination.value.perPage = perPage
            pagination.value.currentPage = 1
            getreasonsWithPagination()
        }

        getreasonsWithPagination()

        return {
            loading,
            items,
            pagination,
            fields,
            changePage,
            changePerPage,
            getreasonsWithPagination
        }
    }
})
